import React, { useState } from 'react';
import { Tab } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { DetailBox } from 'common/components/DetailBox';
import { EmployeeForm } from 'employee/components/EmployeeForm';
import { InviteExistingEmployeeForm } from 'employee/components/InviteExistingEmployeeForm';
import { Tabs } from 'common/components/Tabs';
import { BasePage } from './BasePage';

interface IProps {
    className?: string;
}

const BaseNewEmployeePage = (props: IProps) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (
        event: React.ChangeEvent<{}>,
        newValue: number
    ) => {
        setActiveTab(newValue);
    };

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    return (
        <BasePage pageTitle={t('employee.create.pageTitle')} {...props}>
            <Tabs
                indicatorColor="primary"
                value={activeTab}
                onChange={handleTabChange}
            >
                <Tab label={t('employee.new')} {...a11yProps(0)} />
                <Tab label={t('employee.existing')} {...a11yProps(1)} />
            </Tabs>
            {activeTab === 0 && (
                <DetailBox title={t('employee.create.formTitle')}>
                    <EmployeeForm />
                </DetailBox>
            )}
            {activeTab === 1 && (
                <DetailBox title={t('employee.existing')}>
                    <InviteExistingEmployeeForm />
                </DetailBox>
            )}
        </BasePage>
    );
};

export const NewEmployeePage = styled(BaseNewEmployeePage)`
    ${DetailBox} {
        margin-top: 0;
    }
`;
